import { z } from '@harvestiq/zod';
import { dbClaimDocumentSchema } from './db-claim-documents';

export const deleteClaimDocumentParamsSchema = z.object({
  claimDocumentId: z.string().uuid(),
});

export type DeleteClaimDocumentParams = z.infer<
  typeof deleteClaimDocumentParamsSchema
>;

export const deleteClaimDocumentResponseSchema = z.object({
  claimDocument: dbClaimDocumentSchema.optional(),
  error: z.string().optional(),
});

export type DeleteClaimDocumentResponse = z.infer<
  typeof deleteClaimDocumentResponseSchema
>;
